import { Component, inject } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { MainHeaderComponent } from "@shared/components/organisms/main-header/main-header.component";
import { MainFooterComponent } from "@shared/components/organisms/main-footer/main-footer.component";
import { NavigationBarComponent } from "@shared/components/organisms/navigation-bar/navigation-bar.component";
import { AuthService } from "@core/services/auth.service";
import { AuthHeaderComponent } from "@shared/components/organisms/auth-header/auth-header.component";
import { AuthFooterComponent } from "@shared/components/organisms/auth-footer/auth-footer.component";
import { filter, map, startWith } from "rxjs";
import { toSignal } from "@angular/core/rxjs-interop";
import { BreakpointService } from "@core/services/breakpoint.service";
import { MobileHeaderComponent } from "@shared/components/organisms/mobile-header/mobile-header.component";
import { MobileBottomNavComponent } from "@shared/components/organisms/mobile-bottom-nav/mobile-bottom-nav.component";

@Component({
  selector: "app-conditional-layout",
  imports: [
    MainHeaderComponent,
    MainFooterComponent,
    NavigationBarComponent,
    AuthHeaderComponent,
    AuthFooterComponent,
    MobileHeaderComponent,
    MobileBottomNavComponent,
  ],
  templateUrl: "./conditional-layout.component.html",
  styleUrl: "./conditional-layout.component.scss",
})
export class ConditionalLayoutComponent {
  private readonly authService = inject(AuthService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly breakpointService = inject(BreakpointService);

  readonly isAuthenticated = this.authService.isAuthenticatedSignal;
  readonly isDesktop = this.breakpointService.isDesktop;

  readonly isShowCategoryButton = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => (this.getCurrentRoute()?.snapshot.data["isShowCategoryButton"] as boolean) ?? true),
      startWith((this.getCurrentRoute()?.snapshot.data["isShowCategoryButton"] as boolean) ?? true),
    ),
    { initialValue: true },
  );

  private getCurrentRoute(): ActivatedRoute | null {
    let route = this.route;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
